(function () {
	'use strict';

	angular
		.module('smb-app')
		.factory('smbDocumentDataStore', [
			'$q',
			'sbDocumentService',
			'smbAclService',
			'SMB_RIGHTS',
			'SMB_RIGHTS_TYPE',
			DocumentDataStore
		]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbDocumentDataStore
	 *
	 * @description
	 * A datastore that manages the state of a document and its content.
	 */
	function DocumentDataStore($q, sbDocumentService, smbAclService, SMB_RIGHTS, SMB_RIGHTS_TYPE) {

		var _document = null;
		var _pageCount = null;
		var _pages = [];
		var _acl = null;

		return {
			/**
			 * @ngdoc method
			 * @name smbDocumentDataStore#loadDocument
			 * @methodOf smb-app.smbDocumentDataStore
			 * @kind function
			 *
			 * @description
			 * Loads a document by id
			 *
			 * @param {String} documentId The document id
			 *
			 * @returns {Deferred} Returns a promise that resolves to an object that represents a document.
			 */
			loadDocument: loadDocument,

			loadUserPermissions: loadUserPermissions,
			delete: deleteDocument,

			get document() { return _document; },

			/**
			 * @ngdoc property
			 * @name smbDocumentDataStore#pageCount
			 * @propertyOf smb-app.smbDocumentDataStore
			 * @kind property
			 *
			 * @description
			 * Gets the number of pages in the document
			 *
			 * @returns {number} Returns the number of pages in the selected document.
			 */
			get pageCount() { return _pageCount; },

			/**
			 * @ngdoc property
			 * @name smbDocumentDataStore#pages
			 * @propertyOf smb-app.smbDocumentDataStore
			 * @kind function
			 *
			 * @description
			 * Gets the document pages
			 *
			 * @returns
			 * Returns an array of object that represent the document pages
			 */
			get pages() { return _pages; },

			/**
			 * @ngdoc property
			 * @name smbDocumentDataStore#pageUrls
			 * @propertyOf smb-app.smbDocumentDataStore
			 * @kind property
			 *
			 * @description
			 * Get an array of urls that can be used to retrieve the individual
			 * pages of a document.
			 *
			 * @returns {String[]} An array of urls as strings.
			 */
			get pageUrls() {
				// pxScrollViewer will not retrieve an updated page if the url has not changed
				// which it doesn't in our case
				var cacheBust = new Date().getTime();
				return _pages.map(function(p) { return p.Url + '&airbase_cache_bust=' + cacheBust; });
			},

			get acl() { return _acl; },

			get canEditFields() { return this.canEditStatus; },

			get canEditStatus() { return !!_acl && (_acl.hasAdminAccess() || _acl.hasAllPermissions(SMB_RIGHTS[SMB_RIGHTS_TYPE.editRights].param)); },

			/**
			 * @ngdoc property
			 * @name smbDocumentDataStore#hasFullRights
			 * @propertyOf smb-app.smbDocumentDataStore
			 * @kind property
			 *
			 * @description
			 * Returns true if the current user has full rights to the current document.
			 */
			get hasFullRights() { return !!_acl && (_acl.hasAdminAccess() || _acl.hasFullAccess()); }
		};

		function loadDocument(documentId) {
			return sbDocumentService
				.getDocument(documentId)
				.then(function (docView) {
					_document = docView;
					_pageCount = docView.PageCount;

					_pages = [];
					for (var i = 1; i <= docView.PageCount; i++) {
						_pages.push({
							Id: i,
							Url: docView.PageTemplate.replace(docView.PageTemplateParam, i)
						});
					}

					return _document;
				});
		}

		function loadUserPermissions(documentGroupId) {
			return smbAclService.getUserPermissionsForDocumentGroup(documentGroupId)
				.then(function(acl) {
					_acl = acl;
					return _acl;
				});
		}

		function deleteDocument(purge){
			if(!_document) {
				return $q.reject(new Error('No document loaded.'));
			} 
			
			return sbDocumentService
				.deleteDocument(_document.Embedded.Document.DocumentId, purge)
				.then(function(){
					_document = null;
				});				
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/documentDataStore.js
// module id = 119
// module chunks = 1